<!-- Simple generic loading spinner that centers itself in it's container -->
<template>
	<div class="flex w-full flex-col items-center justify-center gap-2 p-4">
		<ion-spinner name="crescent" />
		<div v-if="message">{{ message }}</div>
	</div>
</template>

<script setup lang="ts">
	import { IonSpinner } from "@ionic/vue";

	defineProps<{
		message?: string;
	}>();
</script>
